import { fetchCurrentUserThunk } from '@/redux/slices/currentUserSlice'
import { getUsageAndBalanceThunk } from '@/redux/slices/usageAndBalanceSlice'
import IosPaywall from '@/modules/iosPaywall/IosPaywall'
import { useAppDispatch } from '@/redux/store'
import { useEffect } from 'react'
import { Stack, useLocalSearchParams } from 'expo-router'
import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import { EntitlementIdentifier } from '@/lib/revenuecat'

export default function IosPaywallPage() {
  const dispatch = useAppDispatch()
  const { recommendedEntitlement } = useLocalSearchParams<{ recommendedEntitlement?: string }>()

  useEffect(() => {
    dispatch(fetchCurrentUserThunk())
    dispatch(getUsageAndBalanceThunk())
  }, [dispatch])

  return (
    <>
      <Stack.Screen options={{ ...buildScreenHeaderItems({}) }} />
      <IosPaywall recommendedEntitlement={recommendedEntitlement as EntitlementIdentifier | undefined} />
    </>
  )
}
